<div class="project-page">
  <header class="project-header">
    <p class="eyebrow">Portfolio :: Dribbler</p>
    <h1>Dribbler</h1>
    <div class="meta-badges">
      <span>Games</span>
      <span>Android</span>
      <span>Java</span>
      <span>Android</span>
    </div>
  </header>

  <div class="content-grid">
    <section class="project-copy">
      <p>
        Dribbler is a game that simulates dribbling a ball with physics inspired by the real world.
        The ball reacts to where it is hit, changing its distance and height as you play.
      </p>

      <ul class="feature-list">
        <li>Responsive ball-dribbling system.</li>
        <li>Multiple difficulty levels.</li>
        <li>Results saved to a database.</li>
        <li>Simple and elegant user interface.</li>
        <li>Designed for quick, addictive play sessions.</li>
      </ul>

      <a class="project-link" target="_blank" href="https://play.google.com/store/apps/details?id=pl.jawegiel.dribbler&hl=en">Download
        on Google Play</a>
    </section>

    <aside class="project-visual screenshot-gallery">
      <img class="phone-shot" src="../../../../assets/images/dribbler_screenshot_1.png"
           alt="Dribbler game screenshot 1">
      <img class="phone-shot" src="../../../../assets/images/dribbler_screenshot_2.png"
           alt="Dribbler game screenshot 2">
      <img class="phone-shot" src="../../../../assets/images/dribbler_screenshot_3.png"
           alt="Dribbler game screenshot 3">
      <img class="phone-shot" src="../../../../assets/images/dribbler_screenshot_4.png"
           alt="Dribbler game screenshot 4">
    </aside>
  </div>
</div>
